import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
import {Cartesian2, Cartesian3, Color, DistanceDisplayCondition, Entity} from "cesium";
/**
 * 员工图层
 */
class WorkerLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.EMPLOYEE;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.map((obj,index) =>{
            let worker={...obj};
            worker.layerName=self.layerName;
            if(worker.longitude && worker.latitude){
                let entity;
                var x=1;
                var flog=true;
                if(worker.workStatus===3){
                    entity=new Entity({
                        position: Cartesian3.fromDegrees(worker.longitude,worker.latitude, CONSTANTS.ALTITUDE),
                        name: worker.empName,
                        id:worker.deviceNo,
                        attributes:worker,
                        point : {
                            show : true, // default
                            color :new Cesium.CallbackProperty(function () {
                                if(flog){
                                    x=x-0.05;
                                    if(x<=0){
                                        flog=false;
                                    }
                                }else{
                                    x=x+0.05;
                                    if(x>=1){
                                        flog=true;
                                    }
                                }
                                return Cesium.Color.RED.withAlpha(x);
                            },false),
                            pixelSize : 10, // default: 1
                            outlineWidth :0
                        },
                        label:{
                            text : worker.empName+"|"+worker.layer+"层",
                            color :Color.fromCssColorString('#fff'),
                            //backgroundColor:Color.fromCssColorString('#fff'),
                            zIndex:1000000,
                            font:'normal 32px MicroSoft YaHei',
                            showBackground : true,
                            scale : 0.4,
                            distanceDisplayCondition : new DistanceDisplayCondition(0, 500),
                            pixelOffset:new Cartesian2(-10, 30),
                            eyeOffset:new Cartesian3(0,0,-100),
                        }
                    })
                }else{
                    entity=new Entity({
                        position: Cartesian3.fromDegrees(worker.longitude,worker.latitude, CONSTANTS.ALTITUDE),
                        name: worker.empName,
                        id:worker.deviceNo,
                        attributes:worker,
                        //立广告牌
                        billboard :{
                            image : require("@/assets/img/map/worker"+worker.workStatus+".png"),
                            show : true,
                            width : 48,
                            height : 48,
                            pixelOffset:new Cesium.Cartesian2(-10, 0),
                            heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
                        },
                        label:{
                            text : worker.empName+"|"+worker.layer+"层",
                            color :Color.fromCssColorString('#fff'),
                            //backgroundColor:Color.fromCssColorString('#fff'),
                            zIndex:1000000,
                            font:'normal 32px MicroSoft YaHei',
                            showBackground : true,
                            scale : 0.4,
                            distanceDisplayCondition : new DistanceDisplayCondition(0, 500),
                            pixelOffset:new Cartesian2(-10, 30),
                            eyeOffset:new Cartesian3(0,0,-100),
                        }
                    })
                }

                self.dataSource.entities.add(entity);
            }
        });
    }
}
export default WorkerLayer;
